import React from "react";
import { Link } from "react-router-dom";

const links = [
  { href: "/impressum", label: "Impressum" },
  { href: "/datenschutz", label: "Datenschutz" },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-white/80 backdrop-blur dark:bg-gray-900/80">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-6 text-sm text-gray-600 dark:text-gray-300 md:flex-row md:items-center md:justify-between">
        <div className="font-semibold text-gray-800 dark:text-gray-100">
          Jingolin &middot; {year}
        </div>
        <div className="flex flex-wrap items-center gap-4">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="hover:text-rose-600 hover:underline"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
